module.exports = __webpack_public_path__ + "static/media/sample-shot.ff0cdf0b.png";